export default "__VITE_ASSET__Ckd_n$42__"